import {useEffect, useState} from 'react';
import {getBankBalances} from "../../api/Api";
import {Table} from 'antd';
import {Link, useNavigate} from "react-router";

export const BankView = ({refresh, onRefresh, onApiFail, props}) => {
    const [balances, setBalances] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {
        getBankBalances().then(r => {
            const result = r.map(l => {
                return {
                    ...l,
                    key: l.id,
                    amount: l.amount ? l.amount: 0
                }
            })

            setBalances(result);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [refresh, onApiFail]);

    const setFocus = (account) => () => {
        navigate(`/bank/${account}`)
    }

    const columns = [
        {
            title: 'Bank',
            dataIndex: 'accountName',
            key: 'accountName',
            render: (val, record) => {
                return <Link to={`/bank/${record.id}`}>{val}</Link>
            }
        },
        {
            title: 'Balance',
            dataIndex: 'amount',
            key: 'amount',
            render: (val, record) => {
                return <div style={{cursor: 'pointer'}} onClick={setFocus(record.id)}>$ {val}</div>
            }
        }
    ]

    return <Table dataSource={balances} columns={columns} />;
}